import { useContext, useEffect, useRef, useState } from "react";
import { AppContext } from "../App";
import { CDN_URL, formatDate, formatMoney } from "../Helpers";
import { TiUser } from "react-icons/ti";
import { FaFemale, FaMale } from "react-icons/fa";
import { STR_FEMALE, STR_IMAGE, STR_MALE } from "../Strings";
import { BsChatDots } from "react-icons/bs";
import { MdAttachFile, MdLocationPin } from "react-icons/md";
import { GiTalk } from "react-icons/gi";
import { IoChatbubble, IoChatbubblesOutline } from "react-icons/io5";

export default function View({ data }) {
	const appContext = useContext(AppContext);

	/* Place states here */
	

	function view() {
		
		appContext.navTo({
			item: 'side-view',
			subItem: 'pharmacy-order',
			extraItem: data.id,
		})
	}

	useEffect(() => {
		//
	}, [data])
	return (
		<div
			style={{
				width: "100%",
				padding: "10px",
				borderBottom: "4px solid var(--surfaceColor)",
			}}
			onClick={view}
		>
			<h6
				style={{
					fontSize: "22px"
				}}
				className="font-bold text-secondary"
			>
				TZS {formatMoney(data.overallCost)}
			</h6>

			<h6
				className="font-bold text-muted"
				style={{
					fontSize: "12px",
					marginTop: "20px",
					marginBottom: "20px"
				}}
			>
				{
					(JSON.parse(data.items)).map((item, i) => {
						return (
							<span
								key={i}
							>
								{item.title},
							</span>
						)
					})
				}
			</h6>

			<h6
				style={{
					fontSize: "12px"
				}}
				className="font-bold text-muted mt-2 mb-2"
			>
				ID: <span className="text-secondary font-bold">{data.uid}</span>
			</h6>

			<h6
				style={{
					fontSize: "12px"
				}}
				className="font-regular mt-4 text-end"
			>
				{formatDate(data.dateCreated)}
			</h6>


		</div>
	)
}
